var map = {
	"./apple.svg": "2e93",
	"./apple_logo.png": "4a4d",
	"./apple_logo@2x.png": "a680",
	"./apple_pay.png": "66a6",
	"./apple_pay.svg": "8972",
	"./apple_pay@2x.png": "91b9",
	"./applea.svg": "711f",
	"./bank_card_approved.png": "f385",
	"./bank_card_approved@2x.png": "1261",
	"./credit_facility.png": "9392",
	"./credit_facility@2x.png": "c690",
	"./discovery_phone.png": "1f4d",
	"./discovery_phone@2x.png": "b062",
	"./handshake.png": "702d",
	"./handshake@2x.png": "3d28",
	"./heart.png": "127c",
	"./heart@2x.png": "561e",
	"./istore_icon_V1.svg": "5b44",
	"./magnifying_glass.png": "90e7",
	"./magnifying_glass@2x.png": "3f62",
	"./percentages.png": "cf0b",
	"./percentages@2x.png": "5fee",
	"./star.png": "f501",
	"./star@2x.png": "3dd4",
	"./timer.png": "b40e",
	"./timer@2x.png": "5a44",
	"./wallet.png": "2d0b",
	"./wallet@2x.png": "6e92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e54";